/* R44 Pay Day - single model filter (allowed makes + extra models, no app) */
(function () {
  var bar = document.getElementById('pd-bar');
  if (!bar) return;
  var modelSel = document.getElementById('pd-model');
  if (!modelSel) return;
  var dataUrl = bar.getAttribute('data-data-url');
  var pv = new URLSearchParams(location.search).get('preview_theme_id');
  if (pv) dataUrl += '&preview_theme_id=' + encodeURIComponent(pv);
  function splitList(s) { return (s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  var modelMakes = splitList(bar.getAttribute('data-model-makes'));
  var extraModels = splitList(bar.getAttribute('data-extra-models'));
  var excludeModels = splitList(bar.getAttribute('data-exclude-models')).map(function (x) { return x.toLowerCase(); });
  var modelAll = bar.getAttribute('data-model-all') || 'All models';
  var defaultEl = document.getElementById('pd-default');
  var resultsEl = document.getElementById('pd-results');
  var gridEl = document.getElementById('pd-results-grid');
  var countEl = document.getElementById('pd-results-count');
  var clearEl = document.getElementById('pd-clear');

  var data = null, loading = false, loaded = false;
  var models = [];
  var extraSet = {}; extraModels.forEach(function (m) { extraSet[m] = 1; });

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function norm(v) { if (v == null) return []; if (Array.isArray(v)) return v.filter(Boolean); return [v]; }

  function buildModels() {
    var toMakes = {}, count = {};
    data.forEach(function (p) {
      var bs = norm(p.b), ms = norm(p.m);
      ms.forEach(function (md) {
        if (!toMakes[md]) toMakes[md] = {};
        bs.forEach(function (mk) { toMakes[md][mk] = 1; });
        count[md] = (count[md] || 0) + 1;
      });
    });
    var out = [];
    Object.keys(count).forEach(function (md) {
      var isExtra = !!extraSet[md];
      var keep = isExtra;
      if (!keep) {
        var mks = toMakes[md] || {};
        for (var i = 0; i < modelMakes.length; i++) { if (mks[modelMakes[i]]) { keep = true; break; } }
      }
      if (keep && !isExtra && excludeModels.length) {
        var low = md.toLowerCase();
        for (var j = 0; j < excludeModels.length; j++) { if (low.indexOf(excludeModels[j]) === 0) { keep = false; break; } }
      }
      if (keep) out.push({ name: md, count: count[md] });
    });
    out.sort(function (a, b) { return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0); });
    models = out;
  }

  function fillModels() {
    var html = '<option value="">' + esc(modelAll) + '</option>';
    models.forEach(function (m) { html += '<option value="' + esc(m.name) + '">' + esc(m.name) + '</option>'; });
    modelSel.innerHTML = html;
    modelSel.disabled = false;
  }

  function fetchPage(pg) { return fetch(dataUrl + '&page=' + pg).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }); }

  function loadAll() {
    if (loading || loaded) return;
    loading = true;
    modelSel.innerHTML = '<option>Loading models…</option>';
    modelSel.disabled = true;
    fetchPage(1).then(function (first) {
      var total = first.total_pages || 1;
      var all = first.products || [];
      var reqs = [];
      for (var pg = 2; pg <= total; pg++) { reqs.push(fetchPage(pg).then(function (d) { return d.products || []; })); }
      return Promise.all(reqs).then(function (pages) {
        pages.forEach(function (a) { all = all.concat(a); });
        data = all; loaded = true; loading = false;
        buildModels(); fillModels();
      });
    }).catch(function () {
      loading = false;
      modelSel.innerHTML = '<option value="">' + esc(modelAll) + '</option>';
      modelSel.disabled = false;
    });
  }

  function showDefault() {
    resultsEl.hidden = true;
    if (defaultEl) defaultEl.hidden = false;
    if (clearEl) clearEl.hidden = true;
  }

  function render(list, label) {
    if (defaultEl) defaultEl.hidden = true;
    resultsEl.hidden = false;
    if (clearEl) clearEl.hidden = false;
    countEl.textContent = list.length + (list.length === 1 ? ' product' : ' products') + (label ? ' — ' + label : '');
    if (!list.length) { gridEl.innerHTML = '<p class="pd-empty">No products in this sale match that model.</p>'; return; }
    var html = '';
    list.forEach(function (p) {
      var img = p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy">' : '';
      var price = p.c ? ('<span class="pd-card__sale">' + p.p + '</span> <s class="pd-card__was">' + p.c + '</s>') : ('<span>' + p.p + '</span>');
      html += '<a class="pd-card" href="' + esc(p.u) + '"><div class="pd-card__img">' + img + '</div><div class="pd-card__t">' + esc(p.t) + '</div><div class="pd-card__p">' + price + '</div></a>';
    });
    gridEl.innerHTML = html;
  }

  function apply() {
    if (!loaded) return;
    var md = modelSel.value;
    if (!md) { showDefault(); return; }
    var matches = data.filter(function (p) { return norm(p.m).indexOf(md) !== -1; });
    render(matches, md);
    if (resultsEl.scrollIntoView) resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  modelSel.addEventListener('change', apply);
  if (clearEl) clearEl.addEventListener('click', function (e) { e.preventDefault(); modelSel.value = ''; showDefault(); });
  loadAll();
})();
